// extracted by mini-css-extract-plugin
export default {"cardImage":"cardImage__1ekWT"};
    if(module.hot) {
      // 1792057487440
      var cssReload = require("../../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  